<template>
    <div> 
        <base-header type="" class="rsgradient pb-3 pb-1 pt-3 pt-md-5">
        </base-header>
         <b-card style="margin: 20px">
             <b-card-header header-tag="header" class="p-1" role="tab">
                Mi Tarjeta MasterCard
            </b-card-header>
            <b-card-body>
                <div class="row form-group">
                    <div class="col-md-12 text-center">
                        <label>¡Ya casi terminamos!</label> 
                    </div>
                </div>   

                <div class="row form-group">
                    <div class="col-md-12 text-center">
                        <label>Por favor revisa los datos</label> 
                    </div>
                </div>   
                
                <div class="row form-group">
                    <div class="col-md-12 text-center" style="font-weight: bolder">
                        <label>Titular</label> 
                    </div>
                </div>  
                
                <div class="row form-group">
                    <div class="col-md-12" style="font-weight: bolder">
                        <label>Nombre</label>
                        <base-input v-model="model.Name" readonly></base-input>
                    </div>
                </div>

                <div class="row form-group">
                    <div class="col-md-12" style="font-weight: bolder">
                        <label>Apellido</label>
                        <base-input v-model="model.Surname" readonly></base-input>
                    </div>
                </div>

                <div class="row form-group">
                    <div class="col-md-12" style="font-weight: bolder">
                        <label>Dni</label>
                        <base-input v-model="model.DocumentNumber" readonly></base-input>
                    </div>
                </div>

                <div class="row form-group">
                    <div class="col-md-12 text-center" style="font-weight: bolder">
                        <label>Domicilio</label> 
                    </div>
                </div> 

                <div class="row form-group">
                    <div class="col-md-12" style="font-weight: bolder">
                        <label>Calle</label>
                        <base-input v-model="OwnerAddres.CompleteStreet" readonly></base-input>
                    </div>
                </div>

                <div class="row form-group">
                    <div class="col-md-12" style="font-weight: bolder">
                        <label>Piso</label>
                        <base-input v-model="OwnerAddres.Floor" readonly></base-input>
                    </div>
                </div>

                <div class="row form-group">
                    <div class="col-md-12" style="font-weight: bolder">
                        <label>Departamento</label>
                        <base-input v-model="OwnerAddres.Departament" readonly></base-input>
                    </div>
                </div>

                 <div class="row form-group">
                    <div class="col-md-12" style="font-weight: bolder">
                        <label>Barrio</label>
                        <base-input v-model="OwnerAddres.Neighborhood" readonly></base-input>
                    </div>
                </div>

                <div class="row form-group">
                    <div class="col-md-12" style="font-weight: bolder">
                        <label>Localidad</label>
                        <base-input v-model="OwnerAddres.PostalCodeAndCity" readonly></base-input>
                    </div>
                </div>

                <div class="row form-group">
                    <div class="col-md-12" style="font-weight: bolder">
                        <label>Provincia</label>
                        <base-input v-model="OwnerAddres.ProvinceName" readonly></base-input>
                    </div>
                </div>

                <div class="row form-group">
                    <div class="col-md-12 text-center" style="font-weight: bolder">
                        <label>Domicilio de entrega</label> 
                    </div>
                </div> 
                
                <div class="form-group" v-if="model.HasNotDeliverAddress">
                     <div class="col-md-12">
                        <label>No se ingresó domicilio de entrega diferente.</label>
                        <label>Mismo del titular.</label>
                     </div>
                </div>
                
                <div class="form-group" v-if="model.HasDeliverAddress">
                    <div class="row form-group" style="font-weight: bolder">
                        <div class="col-md-12">
                            <label>Calle</label>
                            <base-input v-model="DeliverAddress.CompleteStreet" readonly></base-input>
                        </div>
                    </div>

                    <div class="row form-group">
                        <div class="col-md-12" style="font-weight: bolder">
                            <label>Piso</label>
                            <base-input v-model="DeliverAddress.Floor" readonly></base-input>
                        </div>
                    </div>

                    <div class="row form-group">
                        <div class="col-md-12" style="font-weight: bolder">  
                            <label>Departamento</label>
                            <base-input v-model="DeliverAddress.Departament" readonly></base-input>
                        </div>
                    </div>

                       <div class="row form-group">
                        <div class="col-md-12" style="font-weight: bolder">  
                            <label>Barrio</label>
                            <base-input v-model="DeliverAddress.Neighborhood" readonly></base-input>
                        </div>
                    </div>

                    <div class="row form-group">
                        <div class="col-md-12" style="font-weight: bolder">
                            <label>Localidad</label>
                            <base-input v-model="DeliverAddress.PostalCodeAndCity" readonly></base-input>
                        </div>
                    </div>

                    <div class="row form-group">
                        <div class="col-md-12" style="font-weight: bolder">
                            <label>Provincia</label>
                            <base-input v-model="DeliverAddress.ProvinceName" readonly></base-input>
                        </div>
                    </div>
                
                    <div class="row form-group" >
                        <div class="col-md-12 text-center">
                            <save-button text="Finalizar" @click="finalizar"></save-button>
                        </div>
                    </div>
                </div>
            </b-card-body>
        </b-card> 
    </div>
</template>

<style>
</style>

<script>
    import Vue from 'vue'
    import vSelect from 'vue-select'
    Vue.component('v-select', vSelect)
    import 'vue-select/dist/vue-select.css';
    import axiosHelpers from '@/helpers/axiosHelpers';
    import notificationHelpers from '@/helpers/notificationHelpers';

    export default {
        data(){
            return {
                model: {
                Name: "",
                Surname: "",
                DocumentNumber: "",
                HasDeliverAddress: false,
                HasNotDeliverAddress: false
                },
                OwnerAddres: null,
                DeliverAddress: null,
            };
        },
        methods: {
            finalizar() {
                let context = this
                axiosHelpers.axiosPost(
                    "Mastercard/CardGenerationRequest",
                    {
                        AccountID: context.$store.getters.accountID
                    },
                    this,
                    function(data) {
                    if (data.ResponseVM.Result) {
                        context.$router.push({ name: "CardRequestGenerated", params: { welcomeMessage: data.ResponseVM.WelcomeMessage }});
                        }
                    }
                );
            },
            getData() {
                let context = this;  
                axiosHelpers.axiosPost(
                "Mastercard/RequestAccountDataToShowBeforeCardGeneration",
                { 
                    AccountID: context.$store.getters.accountID
                },
                this,
                    function(data) {
                        context.model.Name = data.ResponseVM.Name;
                        context.model.Surname = data.ResponseVM.Surname;
                        context.model.DocumentNumber = data.ResponseVM.DocumentNumber;
                        context.model.HasDeliverAddress = data.ResponseVM.HasDeliverAddress;
                        context.model.HasNotDeliverAddress = !data.ResponseVM.HasDeliverAddress;
                        context.OwnerAddres = data.ResponseVM.AccountAddressOwner;
                        context.DeliverAddress = data.ResponseVM.AccountAddressDeliver;
                    }
                );
            },      
        },
        mounted() {
            this.getData();
        }
    }
</script>